import React from "react";
import { Table, CardWithLable, Spinner, Button } from "@public/ui-toolkit";

const userStatusList = [
  {
    option: "Pending",
    id: "0",
  },
  {
    option: "Active",
    id: "1",
  },
  {
    option: "Rejected",
    id: "2",
  },
];

const AllUsers = ({ data, onClickEdit, loading, onClickCreateUser }) => {
  const columns = [
    { name: "Name", key: "fullName" },
    { name: "Email", key: "emailAddress" },
    {
      name: "Status",
      key: "status",
      renderContent: (row) => userStatusList[row?.status]?.option,
    },
    { name: "Role", key: "role" },
    {
      name: "Actions",
      key: "action",
      component: (row) => (
        <div className="d-flex" style={{ cursor: "pointer" }}>
          <span
            onClick={() => {
              onClickEdit(row.id);
            }}
            className="pe-3"
          >
            <i
              className="fa fa-pencil-square-o icon-action"
              aria-hidden="true"
            ></i>
          </span>
        </div>
      ),
    },
  ];

  return (
    <div>
      <main>
        <div className="main-inner mt-5">
          <div className="container mt-5">
            <div>
              <h2 className="text-center">All Users</h2>
            </div>
            <div className="text-right">
              <Button btnName="+ Create User" onClick={onClickCreateUser} />
            </div>
            {loading ? (
              <Spinner className="text-center" />
            ) : (
              <div
                className="
            edit-profile-container
            p-xxl-5 p-md-4 p-3
            box-shadow
            bg-white
            rounded-large
            mt-5
          "
              >
                <CardWithLable title={"ALL Users"}>
                  <div className="hf-card2-body px-0 pb-0">
                    <div className="hf-table">
                      <Table columns={columns} data={data} />
                    </div>
                  </div>
                </CardWithLable>
              </div>
            )}
          </div>
        </div>
      </main>
    </div>
  );
};

export default AllUsers;
